/* RareTCG Phase 3 — collection/search browse runtime.
 * Shopify's existing facet engine remains the source of truth. This file only
 * rehydrates third-party wishlist controls after AJAX grid replacement. */
(() => {
  if (window.__rtcgMobileBrowsePhase3) return;
  if (!document.querySelector('.rtcg-collection-page')) return;
  window.__rtcgMobileBrowsePhase3 = true;

  const WISHLIST_SELECTOR = '.wishlist-hero-custom-button';
  let observedGrid = null;
  let observer = null;

  const requestWishlistHydration = (button) => {
    if (!(button instanceof HTMLElement)) return;
    if (button.dataset.rtcgWishlistHydrationRequested === 'true') return;
    if (button.childElementCount > 0) return;

    button.dataset.rtcgWishlistHydrationRequested = 'true';
    document.dispatchEvent(
      new CustomEvent('wishlist-hero-add-to-custom-element', { detail: button })
    );
  };

  const hydrateWishlistControls = (scope) => {
    if (!(scope instanceof Element) && scope !== document) return;

    window.RareTCGWishlistBridge?.initializeAll?.(scope);

    if (scope.matches?.(WISHLIST_SELECTOR)) requestWishlistHydration(scope);
    scope.querySelectorAll?.(WISHLIST_SELECTOR).forEach(requestWishlistHydration);
  };

  const observeGrid = () => {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid) return;

    if (grid !== observedGrid) {
      observer?.disconnect();
      observedGrid = grid;
      observer = new MutationObserver((records) => {
        records.forEach((record) => {
          record.addedNodes.forEach((node) => {
            if (node instanceof Element) hydrateWishlistControls(node);
          });
        });
      });
      observer.observe(grid, { childList: true, subtree: true });
    }

    hydrateWishlistControls(grid);
  };

  document.addEventListener('rtcg:collection-updated', observeGrid);
  document.addEventListener('shopify:section:load', observeGrid);
  observeGrid();
})();
